import styled, { css } from 'styled-components';
import LinkComponent from '@components/link';
import { generateScales } from '@helpers/generate-media-queries';
import Image from '@components/image';

export const TitleContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    margin: 0 auto;
    width: 100%;

    &::before {
      content: '';
      display: block;
      width: 5rem;
      height: 0.25rem;
      background-color: ${theme.colors.primary};
      border-radius: 0.125rem;
      margin-bottom: 0.5rem;

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        margin-bottom: 0.25rem;
      }
    }
  `}
`;

export const TextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 1.25rem;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 1rem;
    }
  `}
`;

export const MediaContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      justify-content: center;
    }
  `}
`;

export const StyledImage = styled(Image)`
  mix-blend-mode: multiply;
`;

export const StyledLinkComponent = styled(LinkComponent)`
  ${({ theme }) => css`
    width: fit-content;
    margin: 0;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.black};
    ${generateScales('font-size', theme.fontSize.body.mobile, theme.fontSize.body.desktop, theme)}
    transition: transform 0.125s ease-in-out;

    &:hover {
      transform: scale(1.0375);
      background-color: ${theme.colors.primary}BF;
    }

    &:active {
      transform: scale(0.9625);
    }
  `}
`;

export const StyledItemLinkComponent = styled(LinkComponent)`
  ${({ theme }) => css`
    ${generateScales('font-size', theme.fontSize.small.mobile, theme.fontSize.small.desktop, theme)}
    margin: 0;
  `}
`;

interface FeatureWrapperProps {
  $sectionStyle?: boolean;
}

export const FeatureWrapper = styled.div<FeatureWrapperProps>`
  ${({ theme, $sectionStyle }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4rem;
    border-radius: ${theme.borderRadius.large};
    flex-direction: row;
    padding: ${!$sectionStyle ? '3rem 0' : '4rem 3rem'};
    background-color: ${!$sectionStyle ? 'transparent' : theme.backgroundColors.light}66;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      gap: 3.5rem;
      padding: ${!$sectionStyle ? '2.5rem 0' : '3.5rem 2.5rem'};
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      gap: 2rem;
      flex-direction: column-reverse;
      padding: ${!$sectionStyle ? '2rem 0' : '3rem 2.5rem'};
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      gap: 2rem;
      padding: ${!$sectionStyle ? '1.5rem 0' : '2.5rem 2rem'};
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      border-radius: calc(${theme.borderRadius.large} / 2);
      padding: ${!$sectionStyle ? '1rem 0' : '1.5rem 1rem'};
    }
  `}
`;
